module.exports = __webpack_public_path__ + "static/ClipartRow-1bbc32b4356715bb8c7a56641f8c8fed.gif";